export default __webpack_public_path__ + "static/media/Milestone 25L.e6bcb442.svg";